export default "__VITE_ASSET__YS$6M6sv__"